import axios from 'axios'

async function getAllCodes (query) {
  query = query || {}
  query.sortDesc = true
  query.limitless = true
  return axios.get('/admin/codes', { params: query })
}

async function addCodes (codeDescription) {
  try {
    const res = await axios.post('/admin/codes', codeDescription)
    return res.data.data
  } catch (err) {
    console.log(err)
  }
}

async function enableCodes (id) {
  const res = await axios.put(`/admin/codes/${id}`, { statusId: 2 })
  return res.data.data
}

async function getCodeList (id, query) {
  query = query || {}
  const res = await axios.get(`/admin/codes/${id}/list`, { params: query })
  return res.data
}

async function getCodesPrint (id) {
  const res = await axios.get(`/admin/codes/${id}/print`)
  return res.data
}

async function getActivations (id) {
  try {
    const res = await axios.get(`/admin/codes/${id}/activated`)
    return res.data.data
  } catch (err) {
    console.log(err)
  }
}

export default {
  getAllCodes,
  addCodes,
  enableCodes,
  getCodeList,
  getCodesPrint,
  getActivations
}



// WEBPACK FOOTER //
// ./src/api/codes.js